import type { FooterTemplate } from '@iheartjane/data-access';
import { Card, Flex, Typography } from '@iheartjane/reefer';
import { useFormContext } from 'react-hook-form';

import { PremiumLinks } from '../PremiumLinks';

import styles from './Footer.module.css';

export const FooterLinksSection = () => {
  const formMethods = useFormContext<FooterTemplate>();

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="links"
    >
      <Flex flexDirection="column" gap={24} p={40}>
        <Typography variant="header-bold">Footer links</Typography>
        <Typography>
          You can add 3 sections for links—10 links per section. Leave this
          section blank if you don't want links in your footer.
        </Typography>

        <PremiumLinks
          addButtonLabel="Add footer link"
          allowEmailAndPhone
          controlName="links"
          formMethods={formMethods}
          maxDepth={1}
          maxLabelLength={30}
          maxParents={3}
          maxChildren={10}
        />
      </Flex>
    </Card>
  );
};
